/**
 * BunkerPortsManager — the Bunkers (fuels) curated port list.
 *
 * The panel itself is module-agnostic; this file only binds it to the bunkers
 * module so existing imports and the Fuels Trade Ops tab keep working.
 * See PortsManager.js for the behaviour and PORT_MODULES for the config.
 */

import React from 'react';
import PortsManager from './PortsManager';

const BunkerPortsManager = () => <PortsManager module="bunker" />;

export default BunkerPortsManager;
